@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../../constants/spacing.module.less';

.grid-content {
  flex-grow: 1;
  height: 100%;
  overflow-y: hidden;
}

.grid-and-footer {
  height: 100%;
  width: 100%;
  max-width: calc(100% ~'-' 446px);

  &.no-sidebar {
    max-width: 100%;
  }
}

.edit-grid-wrap-no-filters {
  border-top: 1px solid @grid-page--edit-grid-wrap--border-color;
}

.grid-header {
  background-color: @grid-page--grid-header--background-color;
}

.main-content {
  z-index: 1;
  position: relative;
  flex: 1 1 100%;
  overflow-x: hidden;
  background: @grid-page--main-content--background-color;
}
